import { render, staticRenderFns } from "./JVxeDemo3.vue?vue&type=template&id=7a4565a0&scoped=true"
import script from "./JVxeDemo3.vue?vue&type=script&lang=js"
export * from "./JVxeDemo3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4565a0",
  null
  
)

export default component.exports